export class MissionsFiltersRequest {
  start_date_min_timestamp: number = null;
  start_date_max_timestamp: number = null;
}
